const ITEMS = [
    "Real books, zero waiting",
    "The Bag Drop — from $34.99",
    "30+ cozy book clubs",
    "Swipe to find your next read",
    "Your own Social Media Manager",
];

export const SocialProofStrip = () => (
    <div
        data-testid="social-proof-strip"
        className="border-y border-[#E5D7C5] bg-white/60 backdrop-blur-sm"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 py-5 flex flex-wrap justify-center gap-x-10 gap-y-3 text-sm text-[#6B655C] font-sans">
            {ITEMS.map((it, i) => (
                <span key={it} className="inline-flex items-center gap-2">
                    <span
                        className={`w-1.5 h-1.5 rounded-full ${
                            i % 2 === 0 ? "bg-[#C4956A]" : "bg-[#E86A58]"
                        }`}
                    />
                    {it}
                </span>
            ))}
        </div>
    </div>
);
